import React from 'react';
import { Box, Typography, Grid } from '@mui/joy';
import MetricCard from '../MetricCard';

const StatusBoardAnalytics = ({ tasks }) => {
  const total = tasks.length;
  const completed = tasks.filter(t => t.completed).length;
  const overdue = tasks.filter(t => t.due_date && !t.completed && new Date(t.due_date) < new Date()).length;
  const dueSoon = tasks.filter(t => t.due_date && !t.completed && new Date(t.due_date) >= new Date() && new Date(t.due_date) <= new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)).length;
  const highPriority = tasks.filter(t => Number(t.priority) === 1 && !t.completed).length;

  return (
    <Box sx={{ mb: 4 }}>
      <Typography 
        level="h3" 
        sx={{ mb: 3, color: 'success.700', display: 'flex', alignItems: 'center', gap: 2 }}
        className="fade-in"
      >
        <span className="material-symbols-outlined" style={{ fontSize: '32px', fontFamily: 'Material Symbols Outlined' }}>
          analytics
        </span>
        Task Board Analytics
      </Typography>
      <Grid container spacing={3} className="fade-in-up">
        <Grid xs={12} sm={6} md={2.4}>
          <MetricCard
            title="Total Tasks"
            value={total}
            icon="receipt_long"
            gradientColors={["#00A884", "#007E33"]}
          />
        </Grid>
        <Grid xs={12} sm={6} md={2.4}>
          <MetricCard
            title="Completed"
            value={completed}
            icon="check_circle"
            gradientColors={["#28a745", "#218838"]}
          />
        </Grid>
        <Grid xs={12} sm={6} md={2.4}>
          <MetricCard
            title="Overdue"
            value={overdue}
            icon="error"
            gradientColors={["#dc3545", "#c82333"]}
          />
        </Grid>
        <Grid xs={12} sm={6} md={2.4}>
          <MetricCard
            title="High Priority"
            value={highPriority}
            icon="priority_high"
            gradientColors={["#ff9800", "#f44336"]}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StatusBoardAnalytics;
